///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////
import { createPopper } from '@popperjs/core';

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-tooltip-icon')) {
      // Select parent element for event listener. Help text icons are currently
      // in place inside of the admin section show views as well as various views
      // inside of the process review interface.
      const parentElement = document.querySelector('.process-review-form') ||
                            document.querySelector('.admin-section-summary');

      parentElement.addEventListener('click', (e) => {
        const target = e.target;

        if (target.parentElement.classList.contains('js-tooltip-icon')) {
          const infoIcon = new InfoIcon(target);

          infoIcon.openPopper();
        }
      });

      document.addEventListener('click', (e) => {
        const target = e.target;

        if (!target.parentElement.classList.contains('js-tooltip-icon')) {
          document.querySelectorAll('.tooltip-popper').forEach((item) => {
            const popperWindow = new PopperWindow(item);

            if (popperWindow.popper.style.display == 'flex') {
              popperWindow.closePopper();
            }
          });
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function InfoIcon(target) {
    this.icon   = target.parentElement;
    this.popper = target.parentElement.nextElementSibling;
  }

  function PopperWindow(target) {
    this.icon   = target.previousElementSibling;
    this.popper = target;
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Allows a toggle for the tooltip
  //               to be viewable or hidden for two
  //               different types of poppers.
  //
  InfoIcon.prototype.openPopper = function() {
    if (this.popper.style.display != 'flex') {
      this.popper.style.display = 'flex';
      createPopperToolTip(this.icon, this.popper);

      this.icon.style.color = 'green';
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Closes popper window and resets
  //               help icon color to default black.
  //
  PopperWindow.prototype.closePopper = function() {
    this.popper.style.display = 'none';
    this.icon.style.color = '';
  };


  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Create a 'Popper' with built
  //               in modifiers to manage placement
  //               of the tooltips.
  //
  function createPopperToolTip(icon, popper) {
    // popper options
    const options = {
      placement: 'right-end',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [-10, 10]
          },
        },
      ],
    };

    createPopper(icon, popper, options);
  }
})();
